export const book = [
  '0 0 32 32',
  `
<path fill="none" stroke-linejoin="round" stroke-linecap="round" stroke-miterlimit="4" stroke-width="1.8286" stroke="currentColor" d="M3.976 29.226c-0.002-0.474 0.090-0.944 0.271-1.383s0.446-0.837 0.782-1.172 0.734-0.601 1.172-0.782c0.438-0.18 0.908-0.272 1.383-0.27h20.441v-24.048h-20.441c-0.474-0.002-0.944 0.090-1.383 0.271s-0.837 0.446-1.172 0.782c-0.335 0.335-0.601 0.734-0.782 1.172s-0.272 0.908-0.271 1.383v24.048z"></path>
<path fill="none" stroke-linejoin="round" stroke-linecap="round" stroke-miterlimit="4" stroke-width="1.8286" stroke="currentColor" d="M3.976 29.226v1.202h21.643"></path>

`,
]
